import React, { useEffect, useState } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { Modal, Table, Select } from 'antd';
import { useForm } from 'react-hook-form';
import { toast, confirm } from '@rickylandino/react-messages';
import { DeleteOutlined } from '@ant-design/icons';
import { insertWorkflowItem, workflowItemsState, availableUsersState, updateWorkflowItemRecipients, deleteWorkflowItem } from '../../services/AdminService';
//import { persistentEpicorCompanyState } from '../../../services/UserService';
import SkeletonTable from '../Helpers/SkeletonTable';

const { Option } = Select;
export default function ManageWorkflow(props) {
    const { register, getValues, setValue, control, watch } = useForm();

    const [showAddWorkflowItem, setShowAddWorkflowItem] = useState(false);
    const [workflowItems, setWorkflowItems] = useRecoilState(workflowItemsState);
    const availableUsers = useRecoilValue(availableUsersState);
    const [loading, setLoading] = useState(props.loading);
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    useEffect(() => {
        console.log(workflowItems);

        setLoading(props.loading);
    }, [props.loading]);

    function handleCloseModal() {
        setShowAddWorkflowItem(false);
        setValue('workflowItem', '');
        setValue('workflowType', '');
    }

    function handleSaveWorkflowItem() {
        let postdata = {
            workflowType: getValues().workflowType,
            workflowItem: getValues().workflowItem,
            division: userInfo.jobShopDivision
        }

        if (!postdata.workflowType || !postdata.workflowItem) {
            toast.error("Please fill in all required fields");
        } else {
            insertWorkflowItem(postdata).then(data => {
                if (data) {
                    setWorkflowItems(data);
                    handleCloseModal();
                    toast.success("Workflow Item added successfully");
                } else {
                    toast.error("Something went wrong");
                }
            }).catch(error => {
                toast.error("Something went wrong");
            })
        }
    }

    function handlePrimaryRecipientChange(primaryRecipient, row) {
        console.log(primaryRecipient);
        console.log(row);

        let wfi = [...workflowItems];
        var item;

        if (primaryRecipient !== undefined) {
            item = { ...wfi[row.index] };
        }
        else {
            item = null;
        }

        if (item) {
            item.username = primaryRecipient;
            item.isDirty = true;
        } else {
            item = {
                username: primaryRecipient,
                isDirty: true
            }
        }

        wfi[row.index] = item;
        setWorkflowItems(wfi);
    }

    function handleSaveWorkflowChanges() {
        let updateList = [];
        workflowItems.forEach((item, idx) => {
            if (item.isDirty) {
                updateList.push(item);
            }
        });

        console.log(updateList);

        updateWorkflowItemRecipients(updateList).then(data => {
            if (data) {
                setWorkflowItems(data);
                toast.success("Workflow has been updated");
            } else {
                toast.error("Something went wrong");
            }
        }).catch(error => {
            toast.error("Something went wrong");
        })
    }

    function handleDeleteWorkflowItem(e, record) {
        confirm({
            title: 'You are about to permanently DELETE this Workflow Item',
            content: "Are you sure you would like continue?",
            buttons: ["Yes", "No"],
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {
                deleteWorkflowItem(record).then(data => {
                    if (data) {
                        setWorkflowItems(data);

                        toast.success("Workflow Item dleted successfully");
                    } else {
                        toast.error("Something went wrong");
                    }
                }).catch(error => {
                    toast.error("Something went wrong");
                })

                return 0;
            } else {
                return 0;
            }
        });
    }

    const startingIndex = 0;

    const primaryRecipientFormat = (text, record, index) => {
        return (
            <Select
                placeholder="Please select"
                onChange={(value, idx) => handlePrimaryRecipientChange(value, idx)}
                className="form-control-custom"
                bordered={false}
                value={record?.username || ''}
                allowClear
            >
                <Option index={index + startingIndex} value='JSS Admin Review'>Admin Review Queue</Option>
                {availableUsers.map((e, idx) => <Option index={index + startingIndex} key={index + "a" + idx} value={e.username}>{e.username}</Option>)}
            </Select>
        );
    }

    const columns = [
        {
            dataIndex: 'workflowItems_ID',
            title: 'WorkflowItems_ID',
            key: 'workflowItems_ID',
            hidden: true
        }, {
            title: 'Workflow Item',
            dataIndex: "workflowItem",
            key: 'workflowItem',
            /*            width: 450,*/
            ellipsis: true,
        }, {
            title: 'Recipient',
            key: 'action1',
            render: primaryRecipientFormat,
        }, {
            title: 'Delete',
            key: 'action2',
            width: 120,
            render: (record) => <DeleteOutlined className="text-center hover" style={{ fontSize: '1.2rem', color: 'red' }} onClick={(e) => handleDeleteWorkflowItem(e, record)} />,
            align: 'center'
        }
    ].filter(item => !item.hidden);

    return (
        <>
            <div className="text-end">
                <button type="button" className="btn btn-submit margin-0-10" onClick={() => setShowAddWorkflowItem(true)}>
                    Add Workflow Item
                </button>
            </div>
            <div className="my-3">
                {loading ?
                
                    <SkeletonTable columns={columns} rowCount={5} />
                    :
                    <Table columns={columns} size="small"
                        dataSource={workflowItems} rowKey='workflowItems_ID' />
                }
            </div>

            <button type="button" className="btn btn-submit margin-0-10" onClick={handleSaveWorkflowChanges}>
                Save Changes
            </button>

            <Modal
                visible={showAddWorkflowItem}
                title="Add Workflow Item"
                onOk={handleSaveWorkflowItem}
                onCancel={handleCloseModal}
                footer={[
                    <button className="btn btn-submit me-3" key="0" onClick={handleSaveWorkflowItem}>
                        Save
                    </button>,
                    <button className="btn btn-outline-primary" key="1" onClick={handleCloseModal}>
                        Cancel
                    </button>
                ]}
            >
                <div className="row">
                    <div className="form-group col col-lg-6 col-12">
                        <label className="form-label">Workflow Type <span className="text-danger">*</span></label>
                        <select {...register('workflowType')} className="form-control-custom">
                            <option value=""></option>
                            <option>Exhibitor</option>
                            <option>Show</option>
                        </select>
                    </div>
                    <div className="form-group col col-12">
                        <label className="form-label">Workflow Task <span className="text-danger">*</span></label>
                        <input className="form-control-custom" {...register('workflowItem')} />
                    </div>
                </div>
            </Modal>
        </>    
    );
}